import "./App.css";
import Main1 from "./component/Main1";

function App() {
  return (
    <div className="App">
      <Main1 />
    </div>
  );
}

export default App;
